module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-queen.6e92d135.svg";